/** Fixed simulation rate in Hz. Rendering is decoupled and interpolates (CLAUDE.md conventions). */
export const SIM_TICK_RATE = 30;
/** Seconds per simulation tick. */
export const SIM_DT = 1 / SIM_TICK_RATE;
/** Client input packets per second: one per sim tick (DECISIONS.md #16). */
export const INPUT_RATE = SIM_TICK_RATE;
/** Bumped whenever the client/server wire protocol changes incompatibly. */
export const PROTOCOL_VERSION = 4;
export const GAME_NAME = 'STEELWAKE';
/** Match format (BUILD_PLAN section 7, DECISIONS.md #12). */
export const ROUND_DURATION_SECONDS = 180;
export const ROUNDS_TO_WIN = 2;
export const SPAWN_COUNTDOWN_SECONDS = 10;
//# sourceMappingURL=constants.js.map